<template>
  <div class="basicNav">
    <el-submenu index="5">
      <template slot="title">
        <i class="iconfont icon-jichushezhi"></i>
        <span>{{ptitle}}</span>
      </template>
      <el-menu-item
        v-for="(item,i) in menuList"
        v-show="item.show"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-submenu>
    <!-- <left-nav :menuList="menuList" :ptitle="ptitle" ref="leftNav"></left-nav> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      ptitle: '基础设置',
      menuList: [
        // {
        //   index: '3-1',
        //   title: '店铺设置',
        //   disabled: true,
        //   url: ''
        // },
        {
          index: '5-2',
          title: '分类设置',
          url: '/basic/classify',
          show: false
        },
        {
          index: '5-3',
          title: '品牌管理',
          url: '/basic/brand',
          show: false
        },
        {
          index: '5-1',
          title: '店铺设置',
          show: true,
          url: '/basic/storeSetup'
        },
        {
          index: '5-4',
          title: '商品选品',
          url: '/basic/selection',
          show: true
        }, {
          index: '5-5',
          title: '商品管理',
          url: '/basic/goodsManage',
          show: true
        }
        // , {
        //   index: '3-6',
        //   title: '快递设置',
        //   disabled: true,
        //   url: ''
        // },
        // {
        //   index: '3-7',
        //   title: '推荐管理',
        //   disabled: true,
        //   url: ''
        // }, {
        //   index: '3-8',
        //   title: '售后政策',
        //   disabled: true,
        //   url: ''
        // }
        // {
        //   index: '6',
        //   icon: 'iconfont icon-jiahao-fill',
        //   title: '快速设置',
        //   disabled: true,
        //   url: ''
        // },
        // {
        //   index: '7',
        //   icon: 'iconfont icon-dianzan',
        //   title: '推荐管理',
        //   disabled: true,
        //   url: ''
        // }, {
        //   index: '8',
        //   icon: 'iconfont icon-shuqian',
        //   title: '售后政策',
        //   disabled: true,
        //   url: ''
        // }
      ]
    }
  },
  mounted () {
    this.getCurrentIndex(this.$route.path)
  },
  methods: {
    getCurrentIndex (path) {
      if (path.search('basic') !== -1) {
        let selectItem = this.menuList.filter(item => item.url === path)
        this.rediret(selectItem[0])
      }
    },
    showCBpage () {
      this.menuList[0].show = true
      this.menuList[1].show = true
    },
    rediret (item) {
      this.$emit('rediret', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/leftnav/basicNav.vue